module.exports = __webpack_public_path__ + "static/media/tongyu-headshot.de9bbe98.jpg";